import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import useToggle from 'ext/lib/hooks/use-toggle';
import { selectAccountId } from 'ext/entities/account';
import {
  selectUserAccounts,
  selectHasMultipleAccounts,
} from 'ext/entities/accounts';
import { selectSpoofing } from 'entities/auth/reducer';
import { selectUser } from 'entities/user/reducer';
import UserShape from 'entities/user/shape';
import { selectExperience } from 'entities/experiences/reducer';
import { logout } from 'lib/auth';
import BottomMenuOptions from './BottomMenuOptions';
import AccountsModal from './AccountsModal';
import SpoofingModal from './SpoofingModal';
import LaunchDebuggerModal from './LaunchDebuggerModal';
import { menuOptionsHandler } from './menu-options-handler';

export function BottomMenuManager({
  accountId,
  accounts,
  hasMultipleAccounts,
  isSpoofing,
  appId,
  user,
}) {
  const { isAdmin } = user ?? {};

  const [accountsVisible, toggleAccounts] = useToggle();
  const [spoofingVisible, toggleSpoofing] = useToggle();
  const [launchDebuggerVisible, toggleLaunchDebugger] = useToggle();

  const account = {
    accountId,
    isAdmin,
    hasMultipleAccounts,
    toggleAccounts,
  };

  const spoofing = {
    isSpoofing,
    toggleSpoofing,
  };

  const options = menuOptionsHandler({
    account,
    spoofing,
    appId,
    toggleLaunchDebugger,
    logout,
  });

  return (
    <>
      <BottomMenuOptions options={options} />

      <AccountsModal
        accounts={accounts}
        selected={accountId}
        visible={accountsVisible}
        onClose={toggleAccounts}
      />

      <SpoofingModal visible={spoofingVisible} onClose={toggleSpoofing} />

      <LaunchDebuggerModal
        appId={appId}
        visible={launchDebuggerVisible}
        onClose={toggleLaunchDebugger}
      />
    </>
  );
}

BottomMenuManager.propTypes = {
  accountId: PropTypes.string,
  accounts: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ),
  hasMultipleAccounts: PropTypes.bool,
  isSpoofing: PropTypes.bool,
  appId: PropTypes.string,
  user: UserShape,
};

const mapStateToProps = state => ({
  accountId: selectAccountId(state),
  accounts: selectUserAccounts(state),
  hasMultipleAccounts: selectHasMultipleAccounts(state),
  isSpoofing: selectSpoofing(state),
  appId: selectExperience(state)?.appId,
  user: selectUser(state),
});

export default connect(mapStateToProps)(BottomMenuManager);
